export class PickTimesheetHoursApprove {
    public static readonly type = '[JobsPlacements] Pick a timesheet hours approve';

    constructor(public timesheetHours: Array<number>) { }
}
